// Path: src\Components\PrivateScrims\ManageScrim\ManageDetails.jsx
import React, { useCallback, useEffect, useState } from "react";
import { toastInfo } from "../../../Utilities/toast";
import Diamond from "../../../images/Diamond.png";
import Button from "../../CommonFields/Button";
import TextInput from "../../CommonFields/TextInput";
import { useDropzone } from "react-dropzone";
import { TextField } from "@mui/material";
import { base_apis } from "../../../config/url";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate, useParams } from 'react-router-dom';
import { scrimRoomIdPass, scrimById, scrimSSUpload } from "../../../api/scrim.api";
import { toastError, toastSuccess } from "../../../Utilities/toast";
import { RWebShare } from "react-web-share";
import { shareLink } from "../../../Utilities/helper";
import moment from "moment";
import ListLoader from "../../Common/ListLoader";
import { t } from "i18next";

const ManageDetails = ({ scrimId, setScrim, setIsCancelPopup }) => {
  const navigate = useNavigate()
  const [contestData, setcontestData] = useState([])
  const [status, setScrimStatus] = useState("waiting")

  const [loading, setLoading] = useState(true);
  const [id, setId] = useState('');
  const [roomId, setRoomId] = useState('');
  const [password, setPassword] = useState('');
  const idparams = useParams();
  const [files, setFiles] = useState([]);
  const [isWinningSubmit, setIsWinningSubmit] = useState(true);
  const [isSSUpload, setIsSSUpload] = useState(false);
  const [rmIdpWdSubmit, setRmIdpWdSubmit] = useState(false);
  const [expandedStep, setExpandedStep] = useState(0); 
  const totalPlayers = contestData?.noOfPlayerCapacity;
  const joinedPlayers = contestData?.noOfJoinedPlayer;
  const percentage = (joinedPlayers / totalPlayers) * 100;

  const scrim_id = useParams()
  useEffect(() => {
    setId(scrim_id.id);
  }, [scrim_id])

  useEffect(() => {
    const currentTime = moment();
    const scrimDate = moment(contestData?.date);
    const RPStartTime = moment(scrimDate).subtract(15, "minutes").subtract(parseInt(contestData?.game?.settings?.RPTime), "minutes");
    const RPEndTime = moment(scrimDate).subtract(15, "minutes");

    // const startTime = moment(scrimDate).add(30, "minutes");
    // const SSEndTime = moment(startTime).add(15, "minutes");
    
    var scrimTime = contestData?.time;
    const newDate = moment(new Date(scrimDate)).format("y-MM-DD");
    const newTime = moment(new Date(scrimTime)).format("HH:mm:ss");
    const formate = "YYYY-MM-DD h:m A";
    var dateTime = moment(newDate + " " + newTime);
    const startTime = moment(moment(dateTime), formate);
    const SSEndTime = moment(moment(dateTime).add(15, "minutes"), formate);

    if (currentTime.isBetween(RPStartTime, RPEndTime)) {
      setExpandedStep(1); 
    } else if (currentTime.isBetween(startTime, SSEndTime)) {
      setExpandedStep(2); 
    } else {
      setExpandedStep(0); 
    }
  }, [contestData]);

  const handleAccordionChange = (step) => {
    setExpandedStep((prev) => (prev === step ? -1 : step)); 
  };

  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const year = String(date.getUTCFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    } else {
      return `MM/DD/YYYY`;
    }
  };
  const formatTime = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      // Get hours and minutes
      let hours = date.getUTCHours();
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");
      // Determine AM/PM
      const ampm = hours >= 12 ? "PM" : "AM";
      // Convert hours from 24-hour to 12-hour format
      hours = hours % 12 || 12; // Convert 0 to 12 for midnight
      return `${hours}:${minutes} ${ampm}`;
    } else {
      return `HH:MM AM`;
    }
  };
  const findValueByName = (data, nameToFind) => {
    if (data && data.length > 0) {
      const result = data?.find((item) => item.name === nameToFind);
      return result ? result.value : "N/A"; // Return the value if found, otherwise return null
    } else {
      return "N/A";
    }
  };
  const getCurrencyImg = (data, currencyType) => {
    const result = data?.find((item) => item?.[currencyType]?.img?.default);
    return result
      ? `${base_apis?.imageUrl}${result.inCurrency.img.default}`
      : Diamond;
  };
  const onDrop = useCallback(
    async (acceptedFiles) => {
      const newFiles = [];
      setIsWinningSubmit(true)
      for (const file of acceptedFiles) {
        const formData = new FormData();
        formData.append("file", file, file.path);

        const requestOptions = {
          method: "POST",
          headers: { "x-access-token": localStorage.getItem("viToken") },
          body: formData,
          redirect: "follow",
        };

        try {
          const response = await fetch(`${base_apis.customercare}/upload`, requestOptions);
          const result = await response.text();
          const screenShotUrl = JSON.parse(result)?.item?.screenShot?.default;
          if (screenShotUrl) {
            newFiles.push(screenShotUrl);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          // Handle upload error (e.g., set upload error state)
        }
      }

      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    },
    [setFiles]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });
  const removeimage = (file) => {
    let f = files.filter((ele) => ele != file);
    setFiles(f);
  };

  const updateRoomIdPassword = async () => {
    try {
      const response = await scrimRoomIdPass({ id: scrimId, roomId: roomId, password: password, });
      if (response?.success) {
        toastSuccess(response.data.msg)
        setRIDPDisable(true)
        fetchScrimById()
      } else {
        toastError(response.data.errors[0].msg)
      }
      // setPassword("")
      // setRoomId("")
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // const handleSubmit = async () => {      //error message dont show code is ok
  //   try {
  //     const data = {
  //       id: id,
  //       roomId: roomId,
  //       password: password,
  //     };

  //     const response = await scrimRoomIdPass(data); // Pass the entire data object
  //     console.log('Success:', response);

  //     if (response.success === false) {
  //       if (response.errors && response.errors.length > 0) {
  //         const errorMessages = response.errors.map(error => error.msg).join(', ');
  //         toast.error(errorMessages);
  //       } else {
  //         toast.error("Room ID and Password are required");
  //       }
  //     }

  //   } catch (error) {
  //     console.error('Error:', error);
  //     toast.error("An unexpected error occurred. Please try again later.");
  //   }
  // };



  const [isRIDPDisabled, setRIDPDisable] = useState(false);
  const [isSSTime, setSSTime] = useState(false);
  useEffect(() => {
    setLoading(true)
    fetchScrimById();
  }, []);

  const fetchScrimById = async () => {
    try {
      const response = await scrimById({ id: scrimId });
      if (response?.success && response?.data) {
        setcontestData(response.data)
        setScrim(response?.data)

        setScrimStatus(response?.data?.status)

        //manage enable/disable room id password
        manageRoomIdPassword(response?.data)

        //manage scrim ss uploads
        manageSSUploads(response?.data)

      }
      setLoading(false)
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false)
    }
  };

  const manageRoomIdPassword = (scrim) => {
    setRoomId(scrim?.room?.id)
    setPassword(scrim?.room?.password)
    if (scrim?.room?.id !== null) {
      console.log(scrim?.room?.id !== null)

      setRIDPDisable(true);
      return;
    }
    var dateTime = moment((new Date(scrim.date)));
    const currentTime = moment();
    var RPEndTime = moment(moment(dateTime).subtract(15, "minutes"));
    var RPStartTime = moment(dateTime).subtract(15, "minutes").subtract(parseInt(scrim?.game.settings.RPTime), "minutes");


    let showRIDP = currentTime.isBetween(RPStartTime, RPEndTime);
    console.log('RoomIdPassword')
    console.log('currenct', moment(currentTime).format("y-MM-DD HH:mm:ss"))
    console.log('RPStartTime', moment(RPStartTime).format("y-MM-DD HH:mm:ss"))
    console.log('RPEndTime1111111', moment(RPEndTime).format("y-MM-DD HH:mm:ss"))
    console.log('showRIDP', showRIDP)
    if (showRIDP) {
      setRIDPDisable(false);
    } else {
      setRIDPDisable(true);
    }

  }

  const manageSSUploads = (scrim) => {
    var scrimDate = scrim.date;
    var scrimTime = scrim.time;
    const currentTime = moment();
    const newDate = moment(new Date(scrimDate)).format("y-MM-DD");
    const newTime = moment(new Date(scrimTime)).format("HH:mm:ss");
    const formate = "YYYY-MM-DD h:m A";
    var dateTime = moment(newDate + " " + newTime);
    const startTime = moment(moment(dateTime), formate);
    const SSEndTime = moment(moment(dateTime).add(15, "minutes"), formate);

    console.log('SSUploads')
    console.log('currenct', moment(currentTime).format("y-MM-DD HH:mm:ss"))
    console.log('startTime', moment(startTime).format("y-MM-DD HH:mm:ss"))
    console.log('SSEndTime', moment(SSEndTime).format("y-MM-DD HH:mm:ss"))
    setSSTime(currentTime.isBetween(startTime, SSEndTime));
    // setSSTime(true);
    console.log(status === 'In Review' || status === "Canceled" || status === 'Completed')
    console.log(currentTime.isBetween(startTime, SSEndTime))
    console.log(contestData?.picture?.length, files.length)
    // setSSTime(true)
  }

  const uploadSS = async () => {
    try {
      const response = await scrimSSUpload({ _id: scrimId, pictures: files });
      if (response?.success && response?.data) {
        toastSuccess(response?.data?.msg)
        fetchScrimById()
      } else {
        toastError(response?.data?.errors[0]?.msg)
      }
    } catch (error) {
      console.error("API Error:", error);
      toastError(error?.message || "internal server error")
    }
  }
  const handleFileInputClick = () => {
    document.getElementById("hiddenFileInput").click();
  };

  const closeUploadSS = async () => {
    setIsCancelPopup(true)
  }

  return (
    <div className="height-scrim">
      {!loading &&

        <>
          {contestData && contestData != null ? <>
            <div className="container tournament-card--wrap mt-4 manage-scrim">
              <div className="tournament-card mb-4">
                <div className="card-body d-flex flex-column justify-content-between">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="card-title">
                      {contestData?.title?.length > 25 ? (
                        // scrolldelay="200" for delay marquee
                        <marquee> {contestData?.title}</marquee>
                      ) : (
                        contestData?.title
                      )}
                      {/* {contestData?.title || "N/A"} */}
                    </div>
                    <div className="d-flex">
                      <button
                        className="btn rules-btn "
                        style={{ width: "fit-content" }}
                        onClick={() => {
                          navigator.clipboard.writeText(contestData?.shortCode);
                          toastInfo("short code copied");
                        }}
                      >
                        ID-{contestData?.shortCode || "N/A"}
                      </button>
                      {contestData?.status === 'Waiting' ?
                        <span style={{ cursor: "pointer", marginLeft:"6px" }} onClick={() => navigate(`/private-contest/edit-scrim/${id}`)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                            <path d="M13.1489 13.2048V5.88328C13.1426 5.78579 13.102 5.6945 13.0352 5.62783C12.9685 5.56117 12.8806 5.52409 12.7893 5.52409C12.698 5.52409 12.6102 5.56117 12.5434 5.62783C12.4767 5.6945 12.436 5.78579 12.4297 5.88328V13.2048C12.4295 13.3194 12.4081 13.4328 12.3668 13.5385C12.3256 13.6442 12.2652 13.7402 12.1892 13.8209C12.1132 13.9016 12.023 13.9654 11.9239 14.0087C11.8248 14.052 11.7187 14.0739 11.6117 14.0731H1.53205C1.31708 14.0726 1.11104 13.981 0.959032 13.8183C0.807023 13.6555 0.721422 13.4349 0.720965 13.2048V2.41363C0.721422 2.18349 0.807023 1.96291 0.959032 1.80017C1.11104 1.63743 1.31708 1.54578 1.53205 1.54529H8.37082C8.41815 1.54529 8.46503 1.53531 8.50877 1.51592C8.5525 1.49652 8.59224 1.4681 8.62572 1.43226C8.65919 1.39642 8.68574 1.35388 8.70386 1.30705C8.72197 1.26023 8.7313 1.21005 8.7313 1.15937C8.7313 1.10869 8.72197 1.0585 8.70386 1.01168C8.68574 0.964855 8.65919 0.92231 8.62572 0.886473C8.59224 0.850637 8.5525 0.822209 8.50877 0.802815C8.46503 0.78342 8.41815 0.773437 8.37082 0.773438H1.53205C1.12601 0.774418 0.736855 0.947538 0.449738 1.25492C0.162622 1.56231 0.000915547 1.97893 0 2.41363V13.2048C0.000915547 13.6395 0.162622 14.0561 0.449738 14.3635C0.736855 14.6709 1.12601 14.844 1.53205 14.845H11.6117C11.8133 14.8455 12.0129 14.8034 12.1993 14.7212C12.3857 14.639 12.5551 14.5183 12.6979 14.366C12.8406 14.2137 12.954 14.0327 13.0314 13.8335C13.1088 13.6342 13.1487 13.4206 13.1489 13.2048Z" fill="white" />
                            <path d="M4.70416 7.86265C4.61242 7.95675 4.54445 8.07421 4.50659 8.20404L3.78735 10.7831L6.20328 10.0205C6.32434 9.98208 6.43455 9.91193 6.5239 9.81641L12.4164 3.51724L10.588 1.56348L4.70416 7.86265Z" fill="white" />
                            <path d="M13.8652 1.3798C13.8658 1.10695 13.7906 0.840077 13.6493 0.613053C13.5079 0.386028 13.3067 0.209096 13.0712 0.104719C12.8357 0.000341243 12.5766 -0.0267738 12.3267 0.0268159C12.0768 0.0804056 11.8474 0.212283 11.6677 0.405706L11.0923 1.018L12.9172 2.9699L13.4891 2.35761C13.6094 2.22958 13.7046 2.07716 13.7692 1.90926C13.8338 1.74137 13.8664 1.56137 13.8652 1.3798Z" fill="white" />
                          </svg>
                        </span> : ''
                      }
                    </div>
                  </div>
                  <hr style={{margin:"0.5rem 0"}}></hr>
                  <div className="row">
                    <div className="col-12">
                      <div className="tournament-card-detail">
                        <div className="row">
                          {/* First row (date, round, ID) */}
                          <div className="col-12 tournament-card-box--wrap">
                            <div className="row">
                              <div className="col-3 tournament-card-box">
                                <div className="detail-item">
                                  <div className="tournament-detail-label letter-spacing">
                                    {/* {contestData?.date.length > 7 ? (
                                      // scrolldelay="200" for delay marquee
                                      <marquee> {moment(new Date(contestData?.date)).format('DD/MM/YYYY')}</marquee>
                                    ) : (
                                      moment(new Date(contestData?.date)).format('DD/MM/YYYY')
                                    )} */}

                                    {contestData?.date
                                      ? moment(new Date(contestData?.date)).format('DD/MM/YYYY')
                                      : "N/A"}
                                  </div>
                                  <div className="tournament-detail-value">date</div>
                                </div>
                              </div>
                              <div className="col-3 tournament-card-box">
                                <div className="detail-item">
                                  <div className="tournament-detail-label">
                                    {contestData?.date
                                      ? moment(new Date(contestData?.date)).format('h:mm A')
                                      : "N/A"}
                                  </div>
                                  <div className="tournament-detail-value">time</div>
                                </div>
                              </div>
                              {contestData?.titles?.[0]?.isSelection && contestData?.titles?.[0]?.name && contestData?.titles?.[0]?.value &&
                                <div className="col-3 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      {/* {contestData?.titles?.[0]?.value.length > 5 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee>
                                          {contestData?.titles?.[0]?.value}
                                        </marquee>
                                      ) : (
                                        contestData?.titles?.[0]?.value
                                      )} */}
                                      {contestData?.titles?.[0]?.value}
                                    </div>
                                    <div className="tournament-detail-value">
                                      {/* {contestData?.titles?.[0]?.name.length > 8 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee>
                                          {contestData?.titles?.[0]?.name}
                                        </marquee>
                                      ) : (
                                        contestData?.titles?.[0]?.name
                                      )} */}

                                      {contestData?.titles?.[0]?.name}
                                    </div>
                                  </div>
                                </div>
                              }
                              {contestData?.titles?.[1]?.isSelection && contestData?.titles?.[1]?.name && contestData?.titles?.[1]?.value &&
                                <div className="col-3 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      {/* {contestData?.titles?.[1]?.value.length > 5 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee>
                                          {contestData?.titles?.[1]?.value}
                                        </marquee>
                                      ) : (
                                        contestData?.titles?.[1]?.value
                                      )} */}

                                      {contestData?.titles?.[1]?.value}
                                    </div>
                                    <div className="tournament-detail-value">
                                      {/* {contestData?.titles?.[1]?.name.length > 8 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee >
                                          {contestData?.titles?.[1]?.name}
                                        </marquee>
                                      ) : (
                                        contestData?.titles?.[1]?.name
                                      )} */}

                                      {contestData?.titles?.[1]?.name}
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="tournament-details-winnings tournament-details-winnings-1">
                      <div className="d-flex">
                        <p className="prize-info">
                          players
                          <span className="tournament-prizepool me-4 text-white f-bold">
                            {contestData?.noOfPlayerCapacity}
                          </span>
                        </p>

                        <p className="prize-info">
                          winners
                          <span className="tournament-prizepool text-white f-bold">
                            {contestData.noOfWinner}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    {/* Progress Bar */}
                    <div
                      className="progress"
                      style={{ height: "6px", width: "100%" }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${percentage}%`, // Dynamically set width
                          backgroundColor: "#9F6693", // Change color if 100%
                        }}
                        aria-valuenow={joinedPlayers}
                        aria-valuemin="0"
                        aria-valuemax={totalPlayers}
                      ></div>
                    </div>
                  </div>

                  <p className="progressbar-text mt-2 mb-0">
                    <div>{joinedPlayers} {joinedPlayers > 1 ? 'players' : 'player'} joined</div>
                    <div>{totalPlayers}</div>
                  </p>
                </div>
              </div>
            </div>

            <div className="scrim-box">
              
              {/* <Accordion expanded={activeStep === 0} onChange={() => handleStepChange(0)}> */}
              <Accordion expanded={expandedStep === 0} onChange={() => handleAccordionChange(0)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <div className="d-flex justify-content-between w-100 me-2">
                    <p className="f-14 mb-0">step 1</p>
                    <p className="f-14 mb-0 ">
                      invite your friend
                    </p>
                  </div>
                </AccordionSummary>
                <AccordionDetails>

                  <div className="scrim-btn ">
                    <RWebShare
                      data={shareLink(contestData?.shortCode)}
                      sites={["facebook", "twitter", "whatsapp", "linkedin", "copy"]}
                      onClick={() => { console.log("shared successfully!") }}>
                      <button>invite now</button>
                    </RWebShare>
                    <button className="d-flex justify-content-around" onClick={() => {
                      navigator.clipboard.writeText(contestData?.shortCode);
                      toastInfo("short code copied");
                    }}>
                      {contestData?.shortCode}{" "}
                      <span       >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="18"
                          viewBox="0 0 17 18"
                          fill="none"

                        >

                          <g clip-path="url(#clip0_3714_1979)" >
                            <path
                              d="M16.0137 3.537L12.6927 0.18C12.5793 0.063 12.4173 0 12.2553 0H5.6052C4.3416 0 3.321 1.035 3.321 2.304V3.348H2.2842C1.0206 3.348 0 4.383 0 5.652V15.696C0 16.965 1.0287 18 2.2842 18H10.5948C11.8584 18 12.879 16.965 12.879 15.696V14.652H13.9158C15.1794 14.652 16.2 13.617 16.2 12.348V3.978C16.2 3.816 16.1352 3.654 16.0137 3.537ZM12.879 2.142L14.0778 3.348H12.879V2.142ZM11.6316 15.696C11.6316 16.272 11.1699 16.74 10.5948 16.74H2.2842C1.7091 16.74 1.2474 16.272 1.2474 15.696V5.652C1.2474 5.076 1.7091 4.608 2.2842 4.608H3.321V12.348C3.321 13.617 4.3497 14.652 5.6052 14.652H11.6316V15.696ZM13.9158 13.392H5.6052C5.0301 13.392 4.5684 12.924 4.5684 12.348V2.304C4.5684 1.728 5.0301 1.26 5.6052 1.26H11.6316V3.978C11.6316 4.329 11.907 4.608 12.2553 4.608H14.9526V12.348C14.9526 12.924 14.4909 13.392 13.9158 13.392Z"
                              fill="white"
                            />
                            <path
                              d="M12.2553 10.0439H7.27385C6.93365 10.0439 6.65015 10.3229 6.65015 10.6739C6.65015 11.0249 6.92555 11.3039 7.27385 11.3039H12.2553C12.5955 11.3039 12.879 11.0249 12.879 10.6739C12.879 10.3229 12.6036 10.0439 12.2553 10.0439Z"
                              fill="white"
                            />
                            <path
                              d="M12.2553 6.69629H7.27385C6.93365 6.69629 6.65015 6.97529 6.65015 7.32629C6.65015 7.67729 6.92555 7.95629 7.27385 7.95629H12.2553C12.5955 7.95629 12.879 7.67729 12.879 7.32629C12.879 6.97529 12.6036 6.69629 12.2553 6.69629Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_3714_1979">
                              <rect width="16.2" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  </div>



                </AccordionDetails>
              </Accordion>


            </div>

            <div className="scrim-box" >
            <Accordion expanded={expandedStep === 1} onChange={() => handleAccordionChange(1)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <div className="d-flex justify-content-between w-100 me-2">
                    <p className="f-14 mb-0">step 2</p>
                    <p className="f-14 mb-0 ">room id - password</p>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  {!isRIDPDisabled ? <div className="d-flex justify-content-between mb-2 mt-2">
                    <div className="d-flex flex-column room-id me-3">
                      <TextField
                        id="outlined-required"
                        label={"enter room id"}
                        placeholder={"enter room id"}
                        autoComplete="off"
                        value={roomId}
                        onChange={(e) => setRoomId(e.target.value)}
                        required
                        disabled={isRIDPDisabled}
                      />
                    </div>
                    <div className="d-flex flex-column room-id">
                      <TextField
                        id="outlined-required-password"
                        label={"enter password"}
                        placeholder={"enter password"}
                        autoComplete="off"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={isRIDPDisabled}
                      />
                    </div>
                  </div> : <></>}
                  {isRIDPDisabled && <div className="d-flex justify-content-between mb-2 ">
                    <div className="d-flex flex-column room-id me-3">
                      <div className="detail-item">
                        <div className="tournament-detail-label f-14" style={{ color: "#595969", fontWeight: "bold", fontSize: "0.9rem" }}>
                          {roomId !== null && roomId?.trim() !== '' ? roomId : '-'}
                        </div>
                        <div className="tournament-detail-value">room id</div>
                      </div>
                    </div>
                    <div className="d-flex flex-column room-id">
                      <div className="detail-item">
                        <div className="tournament-detail-label f-14" style={{ color: "#595969", fontWeight: "bold", fontSize: "0.9rem" }}>
                          {password !== null && password?.trim() !== '' ? password : '-'}
                        </div>
                        <div className="tournament-detail-value" style={{ display: "flex", justifyContent: "end" }}>password</div>
                      </div>
                    </div>
                  </div>}
                  <p className="f-12 text-color mb-0">
                    please enter room ID and password at least 15 minutes before the game begins
                  </p>
                  {!isRIDPDisabled &&
                    <div className="mt-4">
                      <Button onClick={updateRoomIdPassword} text="submit" />
                    </div>}
                </AccordionDetails>
              </Accordion>
            </div>
            
            {<div className="scrim-box">
              <Accordion expanded={expandedStep === 2} onChange={() => handleAccordionChange(2)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <div className="d-flex justify-content-between w-100 me-2">
                    <p className="f-14 mb-0">step 3</p>
                    <p className="f-14 mb-0 ">
                      upload screenshot
                    </p>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <div className="w-100 d-flex justify-content-center mb-4">
                      <input
                        type="file"
                        accept="image/*"
                        id="hiddenFileInput"
                        multiple
                        style={{ display: "none" }}
                        onChange={(e) => onDrop(e.target.files)}
                      />
                      {
                        contestData?.picture?.length === 0 &&
                        ((!isSSTime || status === 'In Review' || status === "Canceled" || status === 'Completed')
                          ?
                          <button className="p-1 upload-btn " disabled>
                            {/* <div {...getRootProps()} disabled>
                              <input {...getInputProps()} disabled />
                              <div style={{ padding: "1px 20px" }} disabled>
                                {"choose images"}
                              </div>
                            </div> */}

                            <div style={{ padding: "1px 20px" }} disabled>
                              {"choose images"}
                            </div>
                          </button>
                          :
                          <button className="p-1 upload-btn " onClick={() => handleFileInputClick()}>
                            {/* <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div style={{ padding: "1px 20px" }}>
                                {"choose image"}
                              </div>
                            </div> */}
                             <div style={{ padding: "1px 20px" }} disabled>
                              {"choose images"}
                            </div>
                          </button>)
                      }


                    </div>
                    {contestData?.picture?.length > 0 ? (
                      <div className="d-flex" style={{ overflow:"auto" }} >
                        {contestData?.picture?.map((e) => (
                          <img
                            className="ss-image"
                            style={{
                              width: "80px",
                              height: "130px",
                              marginRight: "20px",
                              marginTop: "0px"
                            }}
                            src={`${base_apis?.imageUrl}${e.url}`}
                            alt="upload"
                          />
                        ))}
                      </div>
                    ) : (
                      files.length !== 0 ? (
                        <div className="d-flex overflow-auto">

                          {files?.map((file, index) => (
                            <div style={{ position: "relative", flex: "0 0 auto",scrollbarWidth:"none", // Each item takes 1/3 of the width
                              maxWidth: "33.33%", // Max width to keep it in three columns
                              padding: "0.5rem" }} className={index > 2 ? "mt-4 " : "mt-3 "}>
                              <img
                                style={{
                                  width: "80px",
                                  height: "130px",
                                  marginRight: "20px",

                                }}
                                src={`${base_apis?.imageUrl}${file}`}
                              />
                              <button
                                className="close-btn"
                                onClick={() => removeimage(file)}
                                style={{ top: "-0.812rem" }}
                              >
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ width: "18px", height: "18px" }}
                                >
                                  <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                                    <circle
                                      cx="16"
                                      cy="16"
                                      r="16"
                                      fill="#82838E"
                                      fill-opacity="0.5"
                                    />
                                  </g>
                                  <rect
                                    x="12.0531"
                                    y="10.9065"
                                    width="13.3333"
                                    height="1.96078"
                                    rx="0.980392"
                                    transform="rotate(45 12.0531 10.9065)"
                                    fill="#F4F4F4"
                                  />
                                  <rect
                                    x="10.6666"
                                    y="20.3345"
                                    width="13.3333"
                                    height="1.96078"
                                    rx="0.980392"
                                    transform="rotate(-45 10.6666 20.3345)"
                                    fill="#F4F4F4"
                                  />
                                  <defs>
                                    <filter
                                      id="filter0_b_2731_8186"
                                      x="-24"
                                      y="-24"
                                      width="80"
                                      height="80"
                                      filterUnits="userSpaceOnUse"
                                      color-interpolation-filters="sRGB"
                                    >
                                      <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                      />
                                      <feGaussianBlur
                                        in="BackgroundImageFix"
                                        stdDeviation="12"
                                      />
                                      <feComposite
                                        in2="SourceAlpha"
                                        operator="in"
                                        result="effect1_backgroundBlur_2731_8186"
                                      />
                                      <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_backgroundBlur_2731_8186"
                                        result="shape"
                                      />
                                    </filter>
                                  </defs>
                                </svg>
                              </button>
                            </div>
                          ))}
                        </div>

                      ) : status === "Canceled" ? (
                        ""
                      ) : (
                        <p
                          style={{
                            color: "#82878D",
                            fontWeight: "500",
                            textAlign: "center",
                          }}
                        ></p>
                      )
                    )}
                    <p className="f-12 text-color mb-0 mt-4">please add the final screenshot after the match is completed</p>


                    {isWinningSubmit && contestData?.picture?.length <= 0 && files.length > 0 && <div className="scrim-btn mt-2 ">
                        {status == "Completed" || status == "Canceled" ? (
                          ""
                        ) : (
                          <button className="cancel-now" onClick={() => closeUploadSS()}>cancel</button>
                        )}
                      <button className="d-flex justify-content-around" onClick={uploadSS}>
                        upload
                      </button>
                    </div>}

                  </div>
                </AccordionDetails>
              </Accordion>
            </div>} </>
            : !loading && <>  <div className='no-record-found-center-my-contestlist'><span className="text-center">{t('common.no_data_found')}</span></div></>}

        </>

      }
      {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}
    </div>
  );
};

export default ManageDetails;
